import ManageStorageRentForm from "@components/forms/storage/ManageStorageRentForm";
import AddOnToggleLink from "@components/ui/plan/AddOnToggleLink";

export function ManageCard() {
  return (
    <ManageStorageRentForm
      action={({ subscribed, loading, disabled, onClick }) => (
        <AddOnToggleLink
          text={subscribed ? "Disable" : "Enable"}
          loading={loading}
          disabled={disabled}
          onClick={onClick}
        />
      )}
    />
  );
}
